import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchMe, login as apiLogin, setToken, clearToken, getToken } from "./api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = not auth, object = auth
  const navigate = useNavigate();

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setUser(false);
      return;
    }
    fetchMe()
      .then(setUser)
      .catch(() => setUser(false));
  }, []);

  const signIn = async (username, password) => {
    const data = await apiLogin(username, password);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signOut = () => {
    clearToken();
    setUser(false);
    navigate("/admin/login");
  };

  return (
    <AdminAuthContext.Provider value={{ user, signIn, signOut }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return ctx;
};
